






























import Vue from 'vue';
import Component from 'vue-class-component';
import firebase, { auth, UserInfo } from 'firebase';
import store from '@/store/store';
import { User, Likers } from '@/types';
import { getModule } from 'vuex-module-decorators';
import Auth from '@/store/modules/auth';
import Dialog from '@/store/modules/dialog';
import { Prop, Watch } from 'vue-property-decorator';
import { getUserData } from '@/utils/database';
import { db } from '@/plugins/firebase';

const authModule = getModule(Auth, store);
const dialogModule = getModule(Dialog, store);

@Component({})
export default class ProfileEditDialog extends Vue {
  @Prop(Boolean)
  value!: boolean;
  user: User | null = null

  get currentUser() {
    return authModule.user
  }

  get show() {
    return dialogModule.profileEditDialog
  }
  set show(value: boolean) {
    dialogModule.openProfileEditDialog({ open: value })
  }

  save() {
    this.show = false
    const uid = authModule.user.uid
    db.collection('users').doc(uid).update({ profile: this.user.profile, website: this.user.website })
  }

  cancel() {
    this.show = false
  }

  @Watch('currentUser')
  bindUser() {
    if (this.currentUser && this.currentUser.uid) {
      this.$bind('user', db.collection('users').doc(this.currentUser.uid))
    }
  }

}
